exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".viewMessagesLink-d2e8d297{font-size:13px;font-weight:500px;line-height:14px}.row-c9214802{padding-bottom:20px}.createdAt-727089ca{font-size:13px;color:#616161;line-height:20px}.empty-f1905dc3{display:flex;justify-content:space-between;padding-bottom:20px}.explainer-20afca35{height:90px;width:185px;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"viewMessagesLink": "viewMessagesLink-d2e8d297",
	"row": "row-c9214802",
	"createdAt": "createdAt-727089ca",
	"empty": "empty-f1905dc3",
	"explainer": "explainer-20afca35"
};